export enum BootstrapCommonIcons {
  SEE = 'bi bi-eye-fill',
  SEARCH = 'bi bi-search',
  DOWNLOAD = 'bi bi-download',
  UPLOAD = 'bi bi-upload',
  DELETE = 'bi bi-trash-fill',
  CANCEL = 'bi bi-x',
  ADD = 'bi bi-plus-circle-fill',
  EDIT = 'bi bi-pencil-square',
  REFRESH = 'bi bi-arrow-clockwise',
}
